export default __webpack_public_path__ + "static/mobile-team-ac5102d3bcc7e4e158c068cf9aa30c12.png";